/**
 * Deli breads data
 * Represents bread options available at the deli
 */

const deliBreads = [
  {
    id: 1,
    name: "Fresh Baked Rye Bread",
    description: "Double or Single Baked. Available as full loaf, half loaf, or by the slice",
    category: "breads"
  },
  {
    id: 2,
    name: "Wheat Bread",
    category: "breads"
  },
  {
    id: 3,
    name: "White Bread",
    category: "breads"
  },
  {
    id: 4,
    name: "Pumpernickel",
    category: "breads"
  },
  {
    id: 5,
    name: "Onion Roll",
    category: "breads"
  },
  {
    id: 6,
    name: "Kaiser Roll",
    category: "breads"
  },
  {
    id: 7,
    name: "Challah",
    category: "breads"
  }
];

module.exports = deliBreads;